import React from "react";
import "../../styles/AboutSection.css";
import heroImg from '../../assets/about_hero.jpg';

export default function HeroBanner() {
  return (
    <section className="about-hero-banner" style={{ backgroundImage: `url(${heroImg})` }}>
      <div className="hero-content">
        <h1>Qui Sommes-Nous ?</h1>
        <p>L'Institut Afro-Méditerranéen d'Analyse des Risques (IAMAR)</p>
      </div>
      <div className="hero-scroll-hint">
        <span>Découvrir notre mission</span>
        <div className="mouse-icon"></div>
      </div>
    </section>
  );
}
